import { render, staticRenderFns } from "./NewQuestionModal.vue?vue&type=template&id=aa99f0ee&"
import script from "./NewQuestionModal.vue?vue&type=script&lang=js&"
export * from "./NewQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa99f0ee')) {
      api.createRecord('aa99f0ee', component.options)
    } else {
      api.reload('aa99f0ee', component.options)
    }
    module.hot.accept("./NewQuestionModal.vue?vue&type=template&id=aa99f0ee&", function () {
      api.rerender('aa99f0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whitelist/components/NewQuestionModal.vue"
export default component.exports